import { useCallback, useState } from 'react';
import BotFormComponent from '../components/bot-form.component';
import { BotCreate, BotUpdate } from '../types/bot.types';
import { useBotCreate } from '../hooks/use-bot.hook';
import { message } from 'antd';
import { useNavigate } from 'react-router-dom';
import {
  extractCreateError,
  extractValidationError,
} from '../../../../../services/extract-api-error.service';
import HeaderRow from '../../../../common/HeaderRow';
import { ValidationError } from '../../../../../types/api-response.types';
import { useTranslation } from 'react-i18next';
import { WithPermissionCheck } from '../../../../auth/WithPermissionCheck';
import PageTitle from '@components/common/PageTitle';

const BotCreateContainer = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [validationErrors, setValidationErrors] = useState<ValidationError[]>([]);

  const { mutateAsync: createBot, isPending } = useBotCreate();

  const onFormSubmit = useCallback(
    async (data: BotCreate | BotUpdate, resetForm: () => void) => {
      // Reset validation errors on new submission
      setValidationErrors([]);

      // For create operations, we know we'll have all required fields
      const createData = data as BotCreate;
      try {
        const response = await createBot(createData);
        message.success(t('crud.create.success', { entity: t('bots.title') }));
        resetForm();
        navigate(`/dashboard/bots/${response.data.id}/update`);
      } catch (error: any) {
        const errorFields = extractValidationError(error);
        setValidationErrors(errorFields);
        const errorMessage = extractCreateError(
          error,
          t('crud.create.error', { entity: t('bots.title') })
        );
        message.error(errorMessage);
      }
    },
    [createBot, navigate, t]
  );

  return (
    <>
      <PageTitle title={t('crud.create.title', { entity: t('bots.title') })} />
      <HeaderRow
        title={t('crud.create.title', { entity: t('bots.title') })}
        showBackButton={true}
      />
      <div className="row mt-3">
        <BotFormComponent
          onFormSubmit={onFormSubmit}
          isLoading={isPending}
          columns={3}
          validationErrors={validationErrors}
        />
      </div>
    </>
  );
};

export default WithPermissionCheck(BotCreateContainer, 'bot.create');
